import { TeamsAdministrationPage } from '@features/portal-tools/sub-features/teams-administration/components/TeamsAdministrationPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/tools/teams-administration/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <TeamsAdministrationPage />
}
